import { useAuth } from '../utils/auth'

const AdminMessageBlock: React.FC = () => {
  const { currentUser } = useAuth()

  if (!currentUser?.adminMessage) {
    return null
  }

  return (
    <div className="adminMessageBlock user-notify">
      {currentUser.adminMessage}
    </div>
  )
}

export default AdminMessageBlock
